var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"900px"}},[_c('l-map',{ref:"leafletMap",attrs:{"crs":_vm.crs,"options":{
      attributionControl: false,
      zoomControl: true,
      zoomSnap: 0,
      zoomDelta: 0.25,
      minZoom: _vm.minZoom,
      maxZoom: _vm.maxZoom,
      bounds: _vm.bounds,
      maxBounds: _vm.bounds
    },"center":_vm.center},on:{"ready":function($event){return _vm.onReady()}}},[_c('l-image-overlay',{attrs:{"url":_vm.image.url,"bounds":_vm.bounds}}),_vm._l((_vm.places),function(mapPlace){return _c('l-circle-marker',{key:mapPlace.name,attrs:{"lat-lng":mapPlace,"color":_vm.circle.color,"radius":_vm.circle.radius},on:{"click":function($event){return _vm.onClick(mapPlace.id)}}},[_c('l-tooltip',{staticClass:"place-tooltip"},[_vm._v(_vm._s(mapPlace.name))])],1)})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }